import { AntSelectOption } from '../AntSelect';

export const hasOptionWithValue = (value: any | any[], options: AntSelectOption[]) =>
  options.some((option) => option.value === value);

export const getExistingSelectedValue = (value: any | any[], options: AntSelectOption[]) => {
  if (Array.isArray(value)) {
    return value.filter((item: any) => hasOptionWithValue(item, options));
  }

  return hasOptionWithValue(value, options) ? value : undefined;
};
